<template>
  <span>
    <v-icon small class="pol-icon">mdi-check-circle-outline</v-icon>POL
  </span>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'POLIcon',
})
</script>

<style lang="scss" scoped>
.pol-icon {
  margin-bottom: 3px;
  margin-right: 4px;
}
</style>
